import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLetterZCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="letter-z-circle"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M8.78125 16.2275V15.2197L13.2285 9.14941V9.04395H8.9043V7.77246H15.0977V8.78027L10.668 14.8506V14.9561H15.209V16.2275H8.78125Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLetterZCircle;
